<template>
  <!-- 带有模板下载以及文件上传的modal -->
  <div class="batch-upload-modal">
    <a-button
      type="primary"
      :icon="icon"
      class="add-btn"
      @click="showModal = true"
      :disabled="this.specialStatus == 1"
    >
      {{ btnText }}
    </a-button>
    <a-modal
      :title="modalTitle"
      :visible="showModal"
      :confirm-loading="approveModalOkLoading"
      :mask-closable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>
        <span>请上传文件：</span>
        <a-upload
          :beforeUpload="handleBeforeUpload"
          :fileList="fileList"
          :remove="handleBatchFileRemove"
          @change="handleBatchFileChange"
        >
          <a-button>
            <a-icon type="upload" />
            选取文件
          </a-button>
        </a-upload>
      </p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'LimitUpload',
  data() {
    return {
      showModal: false,
      fileList: [],
      approveModalOkLoading: false,
      // specialStatus: '',
    }
  },
  props: {
    btnText: {
      type: String,
      default: '批量上传',
    },
    icon: {
      type: String,
      default: 'cloud-upload',
    },
    modalTitle: {
      type: String,
      default: '批量上传',
    },
    specialStatus: {
      type: Number,
    },
  },
  methods: {
    handleOk() {
      this.approveModalOkLoading = true
      this.$emit('ok', this.fileList)
    },
    handleBeforeUploadCanceled() {
      this.approveModalOkLoading = false
    },
    handleCancel() {
      this.showModal = false
      this.fileList = []
      this.approveModalOkLoading = false
    },
    download() {
      this.$emit('download')
    },
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    handleBatchFileRemove() {
      this.fileList = []
    },
    handleBatchFileChange() {
      if (this.fileList.length > 1) {
        this.fileList.shift()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.batch-upload-modal {
  display: inline-block;
}
</style>
